module.exports = __webpack_public_path__ + "static/media/compress-v.67c95047.svg";